var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutTileview2 = function SvgLayoutTileview2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6h-12Zm12 2h-1.25v5.3h5.25V6a4 4 0 0 0-4-4Zm4 7.3h-5.25v5.45h5.25V9.3Zm-7.25-2V2H9.8v5.3h5.45Zm-5.45 2h5.45v5.45H9.8V9.3Zm-2-2V2H6.5a4 4 0 0 0-4 4v1.3h5.3Zm-5.3 2v5.45h5.3V9.3H2.5Zm7.3 7.45h5.45V22H9.8v-5.25ZM18.5 22h-1.25v-5.25h5.25V18a4 4 0 0 1-4 4Zm-16-5.25V18a4 4 0 0 0 4 4h1.3v-5.25H2.5Z",
    fill: "#8F9294"
  })));
};
export default SvgLayoutTileview2;